import IdKortForm from "../IdKortForm";

const IdKortView = () => (
  <div className="container-xxl mt-3 mb-7">
    <div className="card col-10">
      <div className="card-header">
        <h1 className="display-2 mb-0">Bestilling af ID-kort</h1>
        <p>Udfyld nedenstående formular for at bestille et Id-kort.</p>
        {/* Ordlyden er kundens (ADV-324). Står for alle, også advokater, så en fuldmægtig ser
            den, før formularen afviser. */}
        <p className="mb-0">
          <strong>Bemærk:</strong> det er kun advokater, der kan ansøge om
          ID-kort.
        </p>
      </div>
      <div className="card-body">
        <IdKortForm />
      </div>
    </div>
  </div>
);

export default IdKortView;
